module.exports = __webpack_public_path__ + "static/img/club-mate.66ec407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/club-mate.png
// module id = 292
// module chunks = 0